export default {
    path: '/autobid',
    redirect: { name: 'autobid' },
    component: () => import('@/pages/s'),
    children: [
        // 自动投标
        {
            path: 'index',
            name: 'autobid',
            component: () => import('@/pages/autobid/index')
        },
        //创建投标
        {
            path: 'createbid',
            name: 'createbid',
            component: () => import('@/pages/autobid/createbid')
        },
        // 配置回款续投
        {
            path: 'setbid',
            name: 'setbid',
            component: () => import('@/pages/autobid/setbid')
        }
    
    ]
}
